import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import * as globals from '../globals';

@Injectable()
export class S3CredService {

  private projectS3CredsUrl = globals.APIURL + '/projects/s3/';
  private quoteS3CredsUrl = globals.APIURL + '/admin/quote/s3/';
  private logoS3CredsUrl = globals.APIURL + '/admin/settings/s3';

  constructor(private http: Http, public authHttp: AuthHttp) { }

  getProjectS3Creds(projectid: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('S3 URL:', this.projectS3CredsUrl + projectid);
    return this.authHttp.get(this.projectS3CredsUrl + projectid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getQuoteS3Creds(quoteid: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('S3 URL:', this.quoteS3CredsUrl + quoteid);
    return this.authHttp.get(this.quoteS3CredsUrl + quoteid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getLogoS3Creds(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('S3 URL:', this.logoS3CredsUrl );
    return this.authHttp.get(this.logoS3CredsUrl , options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/s3-cred-service.ts